import React from 'react'
import android from '../assets/images/android.webp'
import windows from '../assets/images/windows.webp'
import ios from '../assets/images/ios.webp'
import amazon from '../assets/images/amazon.webp'
import linux from '../assets/images/linux.webp'
import DownloadClicEvent from '../components/Analytics/DownloadClickEvent'


// This part was created to redirect to store depanding on UTM, using the utm for cid etc
function getParameterByName(name, url = typeof window !== 'undefined' ? window.location.href : '') {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
const utmToCid = getParameterByName('utm_content');
const comeBack = typeof window !== 'undefined' && window.location.href.includes('comeback');
const trueUtm = typeof window !== 'undefined' && window.location.href.includes('utm_content')
const trueUtm_ = typeof window !== 'undefined' && window.location.href.includes('utm_')
const utmContent = trueUtm && comeBack ? window.location.href.split('?').pop().split('&').slice(2).join('&') : trueUtm && !comeBack ? window.location.href.split('?').pop() : '';
const utm_ = trueUtm_ && !trueUtm && comeBack ? window.location.href.split('?').pop().split('&').slice(2).join('&') : trueUtm_ && !trueUtm ? window.location.href.split('?').pop() : '';
// till here

export const dropDownData = {
  android: (
    <a
      href={utmContent ? `https://play.google.com/store/apps/details?id=me.bluemail.mail&${utmContent}` : ( utm_ ? `https://play.google.com/store/apps/details?id=me.bluemail.mail&${utm_}` : 'https://play.google.com/store/apps/details?id=me.bluemail.mail')}
      style={{ display: 'block', width: '100%', marginLeft: '1px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Android')} className="platform-button">
        <img
          src={'/img/drop-down/Group-24.svg'}
          alt="android"
          style={{ width: '20px', marginRight: '10px', height: '22.27px' }}
        />
        {'Download for Android'}
      </button>
    </a>
  ),

    /*
  linux_deb: (
    <a
      href={'https://download.bluemail.me/BlueMail/deb/BlueMail.deb'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Linux')} className="platform-button">
        <img
          src={'/img/drop-down/Openlogo-debianV2.svg'}
          alt="linux"
          style={{ width: '20px', marginRight: '12px' }}
        />
        {'Download for Linux DEB'}
      </button>
    </a>
  ),
  */
  ios: (
    <a
      href={
        'https://apps.apple.com/us/app/blue-mail-email-mailbox/id1063729305'
      }
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('iOS')} className="platform-button" style={{ justifyContent: 'center' }}>
        <img
          src={'/img/drop-down/Group.svg'}
          alt="ios"
          style={{ width: '20px', marginRight: '12px' }}
        />
        {'Download for iOS'}
      </button>
    </a>
  ),
  ios_main: (
    <a
      href={
        'https://apps.apple.com/us/app/blue-mail-email-mailbox/id1063729305'
      }
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('iOS')} className="platform-button" style={{ justifyContent: 'center' }}>
        <img
          src={'/img/drop-down/Group-white.svg'}
          alt="ios"
          style={{ width: '20px', marginRight: '12px' }}
        />
        {'Download for iOS'}
      </button>
    </a>
  ),

  windows_9_10_main: (
    <a
    href={ utmContent ? `https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=${utmToCid}` : 'https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=dl'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Windows')} className="platform-button">
        <img
          src={'/img/drop-down/icon-1-white.svg'}
          alt="win"
          style={{ width: '20px', height: '24px', marginRight: '12px' }}
        />
        {'Download for Windows 10'}
      </button>
    </a>
  ),
  windows_11: (
    <a
    href={ utmContent ? `https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=${utmToCid}` : 'https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=dl'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Windows')} className="platform-button">
        <img
          src={'/img/drop-down/win-11-blue.svg'}
          alt="win"
          style={{ width: '20px', height: '24px', marginRight: '12px' }}
        />
        {'Download for Windows 11, 10'}
      </button>
    </a>
  ),
  windows_11_main: (
    <a
    href={ utmContent ? `https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=${utmToCid}` : 'https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=dl'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Windows')} className="platform-button">
        <img
          src={'/img/drop-down/win-11-white.svg'}
          alt="win"
          style={{ width: '20px', height: '24px', marginRight: '12px' }}
        />
        {'Download for Windows 11'}
      </button>
    </a>
  ),
  /*
  windows_9_10: (
    <a
      
    href={'/desktop/windows'}
   // href={ utmContent ? `https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=${utmToCid}` : 'https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=dl'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Windows')} className="platform-button">
        <img
          src={'/img/drop-down/icon-1-blue.svg'}
          alt="win"
          style={{ width: '20px', height: '24px', marginRight: '12px' }}
        />
        {'Download for Windows (exe)'}
      </button>
    </a>
  ),
  */
  windows_9_10_others: (
    <a
    href={ utmContent ? `https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=${utmToCid}` : 'https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=dl'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Windows')} className="platform-button">
        <img
          src={'/img/drop-down/icon-1-blue.svg'}
          alt="win"
          style={{ width: '20px', height: '24px', marginRight: '12px' }}
        />
        {'Download for Windows 11, 10'}
      </button>
    </a>
  ),
  windows_9_10_main_others: (
    <a
   href={ utmContent ? `https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=${utmToCid}` : 'https://apps.microsoft.com/store/detail/blue-mail-email-calendar/9PMHZVM588P4?cid=dl'}
     
   style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Windows')} className="platform-button">
        <img
          src={'/img/drop-down/icon-1-white.svg'}
          alt="win"
          style={{ width: '20px', height: '24px', marginRight: '12px' }}
        />
        {'Download for Windows 11, 10'}
      </button>
    </a>
  ),

  // https://download.bluemail.me/BlueMail/BlueMail-1.140.34.exe

  //      href={'https://download.bluemail.me/BlueMail-Desktop-Installer.exe'}
  //https://download.bluemail.me/BlueMail-Desktop-Installer.exe

  windows_7_8: (
    <a
      href={'/desktop/windows'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Windows')} className="platform-button">
        <img
          src={'/img/drop-down/Windows7.svg'}
          alt="win"
          style={{ width: '24px', height: '24px', marginRight: '8px' }}
        />
        {'Download for Windows (exe)'}
      </button>
    </a>
  ),
  mac: (
    <a
      href={'https://apps.apple.com/us/app/bluemail/id1458754578?mt=12'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Mac')} className="platform-button" style={{ justifyContent: 'center' }}>
        <img
          src={'/img/drop-down/Group.svg'}
          alt="mac"
          style={{ width: '20px', marginRight: '18px', marginBottom: '3px' }}
        />
        {'Download for Mac'}
      </button>
    </a>
  ),
  mac_main: (
    <a
      href={'https://apps.apple.com/us/app/bluemail/id1458754578?mt=12'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Mac')} className="platform-button" style={{ justifyContent: 'center' }}>
        <img
          src={'/img/drop-down/Group-white.svg'}
          alt="mac"
          style={{ width: '20px', marginRight: '18px', marginBottom: '3px' }}
        />
        {'Download for Mac'}
      </button>
    </a>
  ),
  amazon: (
    <a
      href={'https://www.amazon.com/BlueMail-Inc/dp/B01DUUITZO'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Amazon')} className="platform-button">
        <img
          src={'/img/drop-down/Style_2_copy_3.svg'}
          alt={'amazon'}
          style={{ width: '20px', height: '24px', marginRight: '12px' }}
        />
        {'Download for Amazon'}
      </button>
    </a>
  ),
  huawei: (
    <a
      href={'https://appgallery.huawei.com/app/C100838435'}
      style={{ display: 'block', width: '100%', marginLeft:'-2px', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Huawei')} className="platform-button">
        <img
          src={'/img/drop-down/Huawei-AppGallery.svg'}
          alt={'huawei'}
          style={{ width: '25px', height: '25px', marginRight: '9px' }}
        />
        {'Download for Huawei'}
      </button>
    </a>
  ),
  linux_prm: (
    <a
      href={'https://download.bluemail.me/BlueMail/rpm/BlueMail.rpm'}
      style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer"
    >
      <button onClick={() => DownloadClicEvent('Linux')} className="platform-button">
        <img
          src={'/img/drop-down/RedHat.svg'}
          alt="lin"
          style={{ width: '20px', marginRight: '12px' }}
        />
        {'Download for Linux RPM'}
      </button>
    </a>
  ),
  linux_snap: (
    <a href={'https://snapcraft.io/bluemail'} style={{ display: 'block', width: '100%', marginRight: '2px' }} target="_blank" rel="noreferrer">
      <button onClick={() => DownloadClicEvent('Linux')} className="platform-button">
        <img
          src={'https://avatars0.githubusercontent.com/u/19532717?s=400&v=4'}
          alt={'lin'}
          style={{ width: '24px', marginRight: '8px' }}
        />
        {'Download for Linux SNAP'}
      </button>
    </a>
  ),
}

export const platformString = {
  ios: (
    <div className="platform-string-wrapper">
        <img src={windows} alt="windows" />
        <img src={ios} alt="ios" />
        <img src={android} alt="android" />
        <img src={linux} alt="linux" />
        <img src={amazon} alt="amazon" />
        
    </div>
  ),

  windows_9_10: (
    <div className="platform-string-wrapper">
        <img src={windows} alt="windows" />
        <img src={ios} alt="ios" />
        <img src={android} alt="android" />
        <img src={linux} alt="linux" />
        <img src={amazon} alt="amazon" />
    </div>
  ),
  android: (
    <div className="platform-string-wrapper">
        <img src={windows} alt="windows" />
        <img src={ios} alt="ios" />
        <img src={android} alt="android" />
        <img src={linux} alt="linux" />
        <img src={amazon} alt="amazon" />
    </div>
  ),
  mac: (
    <div className="platform-string-wrapper">
        <img src={windows} alt="windows" />
        <img src={ios} alt="ios" />
        <img src={android} alt="android" />
        <img src={linux} alt="linux" />
        <img src={amazon} alt="amazon" />
    </div>
  ),
  amazon: (
    <div className="platform-string-wrapper">
        <img src={windows} alt="windows" />
        <img src={ios} alt="ios" />
        <img src={android} alt="android" />
        <img src={linux} alt="linux" />
        <img src={amazon} alt="amazon" />
    </div>
  ),
  linux_snap: (
    <div className="platform-string-wrapper">
        <img src={windows} alt="windows" />
        <img src={ios} alt="ios" />
        <img src={android} alt="android" />
        <img src={linux} alt="linux" />
        <img src={amazon} alt="amazon" />
    </div>
  ),
}
